module.exports = "/img/_/_/_/assets/images//card_with_level.png?7f9864d8bc4d40111d472a21dd503427";